{
  "_comment": "ISO_A3 → basemap country name lookup for the Atlas Map Quiz POC. Names match public/data/atlas/basemap-50m.json (Natural Earth conventions). Only countries referenced by the Period 2 Empires quiz are included.",
  "ALB": "Albania",
  "ARM": "Armenia",
  "AGO": "Angola",
  "ARG": "Argentina",
  "AZE": "Azerbaijan",
  "BGD": "Bangladesh",
  "BGR": "Bulgaria",
  "BIH": "Bosnia and Herz.",
  "BLR": "Belarus",
  "BOL": "Bolivia",
  "BRA": "Brazil",
  "BFA": "Burkina Faso",
  "CHL": "Chile",
  "CHN": "China",
  "COL": "Colombia",
  "CPV": "Cabo Verde",
  "CRI": "Costa Rica",
  "CUB": "Cuba",
  "DOM": "Dominican Rep.",
  "DZA": "Algeria",
  "ECU": "Ecuador",
  "EGY": "Egypt",
  "ESP": "Spain",
  "GRC": "Greece",
  "GTM": "Guatemala",
  "GNB": "Guinea-Bissau",
  "HND": "Honduras",
  "IND": "India",
  "IRN": "Iran",
  "IRQ": "Iraq",
  "ISR": "Israel",
  "JOR": "Jordan",
  "JPN": "Japan",
  "KAZ": "Kazakhstan",
  "LBN": "Lebanon",
  "LBY": "Libya",
  "MEX": "Mexico",
  "MKD": "Macedonia",
  "MLI": "Mali",
  "MNE": "Montenegro",
  "MNG": "Mongolia",
  "MOZ": "Mozambique",
  "NER": "Niger",
  "NIC": "Nicaragua",
  "PAK": "Pakistan",
  "PAN": "Panama",
  "PER": "Peru",
  "PHL": "Philippines",
  "PRT": "Portugal",
  "PRY": "Paraguay",
  "PSE": "Palestine",
  "ROU": "Romania",
  "RUS": "Russia",
  "SAU": "Saudi Arabia",
  "SLV": "El Salvador",
  "SRB": "Serbia",
  "SYR": "Syria",
  "TUN": "Tunisia",
  "TUR": "Turkey",
  "UKR": "Ukraine",
  "URY": "Uruguay",
  "VEN": "Venezuela",
  "YEM": "Yemen"
}
